<div class="w-100 totals">
  @if (mode === 'A' || mode === 'amount') {
    <table class="w-100">
      <tr>
        <td>
          <h5 class="me-2 text-right">Total Amount to Invest:</h5>
        </td>
        <td style="width: 1%">
          <h5 class="me-2">
            {{ totalAmount | currency }}
          </h5>
        </td>
      </tr>
      <tr>
        <td>
          <h5 class="me-2 text-right">Amount Allocated:</h5>
        </td>
        <td>
          <h5 class="me-2">{{ totalInvestment | currency: 'USD' }}</h5>
        </td>
      </tr>
      <tr>
        <td>
          <h5 class="me-2 text-right">Amount Left to Allocate:</h5>
        </td>
        <td>
          <h5 class="me-2">
            {{ totalAmount - totalInvestment | currency: 'USD' }}
          </h5>
        </td>
      </tr>
    </table>
  }

  @if (mode === 'P' || mode === 'percent') {
    <table class="w-100">
      <tr>
        <td>
          <h5 class="me-2 text-right">Total Amount to Invest:</h5>
        </td>
        <td style="width: 1%">
          <h5 class="me-2">
            {{
              (field.parent.model.ValidateProduct.InvestmentWizard_AssetAmount
                ? makeNumber(
                    field.parent.model.ValidateProduct
                      .InvestmentWizard_AssetAmount
                  )
                : 0
              ) | currency
            }}
          </h5>
        </td>
      </tr>
      <tr>
        <td>
          <h5 class="me-2 text-right">Percent Allocated:</h5>
        </td>
        <td>
          <h5 class="me-2">{{ totalInvestment }}%</h5>
        </td>
      </tr>
      <tr>
        <td>
          <h5 class="me-2 text-right">Percent Left to Allocate:</h5>
        </td>
        <td>
          <h5 class="me-2">{{ percentLeft }}%</h5>
        </td>
      </tr>
    </table>
  }
</div>
